<template>
    <div class="siren-searchbar-loading">
        <div class="siren-searchbar-loading__header">
            <CompassSkeleton variant="square" class="siren-searchbar-loading__icon" />
            <CompassSkeleton class="siren-searchbar-loading__title" size="large" />
        </div>
        <div>
            <CompassSkeleton class="siren-searchbar-loading__siret" />
            <CompassSkeleton class="siren-searchbar-loading__address" />
        </div>
    </div>
</template>
<style lang="scss" scoped>
.siren-searchbar-loading {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: var(--spacing-0);

    &__header {
        color: var(--colors-common-text-standard-default);
        display: flex;
        gap: var(--spacing-0);
    }

    &__icon {
        flex-shrink: 0;
        height: 20px;
        width: 20px;

        &:deep(.compass-skeleton__square) {
            height: 100%;
            width: 100%;
        }
    }

    &__title {
        flex: 0 1 50%;
    }

    &__siret {
        margin: 0 0 2px;
        max-width: 100px;
    }

    &__address {
        max-width: 85%;
    }
}
</style>
